import { useState } from "react";
import { Monitor, Sun, Moon } from "lucide-react";
import { useApi } from "@/lib/api";
import { theme } from "@/lib/theme";

const OPTS = [["system", Monitor, "Match device"], ["light", Sun, "Light"], ["dark", Moon, "Dark"]];

export const ThemeToggle = ({ className = "", testid = "theme-toggle", compact = false }) => {
  const api = useApi();
  const [v, setV] = useState(theme.get());
  const pick = (x) => { setV(x); theme.set(x); api("put", "/me/theme", { theme: x }).catch(() => {}); };
  if (compact) {
    const i = OPTS.findIndex(([k]) => k === v);
    const [, I, l] = OPTS[i];
    const next = OPTS[(i + 1) % OPTS.length];
    return (
      <button type="button" onClick={() => pick(next[0])} title={`Look: ${l}. Tap for ${next[2]}`} aria-label={`Look: ${l}. Tap for ${next[2]}`} data-testid={testid}
        className={`flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-600 ${className}`}>
        <I className="h-4 w-4" />
      </button>
    );
  }
  return (
    <div className={`flex rounded-full border border-slate-200 bg-slate-50 p-0.5 ${className}`} role="radiogroup" aria-label="Look" data-testid={testid}>
      {OPTS.map(([k, I, l]) => (
        <button key={k} type="button" role="radio" aria-checked={v === k} title={l} aria-label={l} onClick={() => pick(k)} data-testid={`${testid}-${k}`}
          className={`flex flex-1 items-center justify-center rounded-full px-2.5 py-1.5 transition-colors ${v === k ? "bg-white text-teal-700 shadow-sm" : "text-slate-500 hover:text-slate-900"}`}>
          <I className="h-4 w-4" />
        </button>
      ))}
    </div>
  );
};
